//------------------------------------------------------ externos
import { createClient } from "@supabase/supabase-js";
import { fetchParaSupabase } from "./escriturasEnCurso";

//------------------------------------------------------ config
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  // eslint-disable-next-line no-console
  console.error(
    "Faltan REACT_APP_SUPABASE_URL / REACT_APP_SUPABASE_ANON_KEY en el .env",
  );
}

/* Los pedidos pasan por `fetchParaSupabase` sólo para contar las escrituras
 * que están viajando: CRT y MIC no se recargan solos mientras haya alguna
 * (Fabián e Igna, 09/10; ver escriturasEnCurso.js). No cambia ningún pedido. */
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  global: { fetch: fetchParaSupabase() },
});
